module.exports = __webpack_public_path__ + "static/media/menuBtn.f268b4b7.svg";